import React, { useMemo } from 'react';

import { valueof } from '../../../stores/types/types';
import Icon, { COLORS, ICONS } from '../../general-components/icon';

interface ScheduledStreamCardProps {
	date: Date;
	location?: string;
	badge?: string;
	actionIcon?: valueof<typeof ICONS>;
	actionHandler?: () => void;
}

export default function ScheduledStreamCard({
	date,
	location = 'Brandlive',
	badge = 'Stream',
	actionIcon = ICONS.EDIT,
	actionHandler = undefined,
}: ScheduledStreamCardProps) {
	const dateString = useMemo((): string => {
		const locale = 'en-US';
		const {
			fmtMonthDay,
			fmtTime,
		} = {
			fmtMonthDay: date.toLocaleString(locale, {
				month: 'short',
				day: 'numeric',
			}),
			fmtTime: date.toLocaleTimeString(locale, {
				hour: 'numeric',
				minute: 'numeric',
				timeZoneName: 'short',
			}),
		};

		return `${fmtMonthDay} at ${fmtTime}`;
	}, [date]);

	return (
		<div className="scheduled-stream-card">
			<div className="scheduled-stream-card__badge bl-font-c1">
				{badge}
			</div>
			<div className="scheduled-stream-card__content bl-font-s3">
				<div className="scheduled-stream-card__title">
					{`Scheduled for ${dateString}`}
				</div>
				<div className="scheduled-stream-card__body">
					{`Streaming to ${location}`}
				</div>
			</div>
			{actionHandler && (
				<div className="scheduled-stream-card__action">
					<button
						className="scheduled-stream-card__action-button"
						type="button"
						onClick={actionHandler}
						data-testid="ssc-action-button"
					>
						<Icon
							name={actionIcon}
							size={13}
							color={COLORS.TEXT_GRAY_1200}
						/>
					</button>
				</div>
			)}
		</div>
	);
}
